var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9999 32.5H34.6666V36.8333H38.9999M38.9999 23.8333H34.6666V28.1667H38.9999M43.3332 41.1667H25.9999V36.8333H30.3333V32.5H25.9999V28.1667H30.3333V23.8333H25.9999V19.5H43.3332M21.6666 15.1667H17.3333V10.8333H21.6666M21.6666 23.8333H17.3333V19.5H21.6666M21.6666 32.5H17.3333V28.1667H21.6666M21.6666 41.1667H17.3333V36.8333H21.6666M12.9999 15.1667H8.66658V10.8333H12.9999M12.9999 23.8333H8.66658V19.5H12.9999M12.9999 32.5H8.66658V28.1667H12.9999M12.9999 41.1667H8.66658V36.8333H12.9999M25.9999 15.1667V6.5H4.33325V45.5H47.6666V15.1667H25.9999Z",
    fill: "#717E83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessImage);
export default __webpack_public_path__ + "static/media/businessImage.837d54c7d51d88eac96732202fc75530.svg";
export { ForwardRef as ReactComponent };